import React, {Component} from 'react';
import PropTypes from 'prop-types'

import 'styles/MapMarker.scss';

export default class MapMarkerComponent extends Component {
  static propTypes = {
    text: PropTypes.string
  };

  static defaultProps = {};
  render() {
    return (
       <div className="map-marker">
          {this.props.text}
       </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/MapMarkerComponent.js